import React, { useEffect, useState } from "react";
import AddressComponent from "../../components/AddressComponent";
import Title from "../../components/Title";
import LockIcon from "../../assets/padlock.svg";
import notify from "../../components/UI/toast";
import {
  addAddress,
  deleteAddress,
  getAddresses,
  editAddresses,
} from "../../components/AddressComponent/services/addressService";
import { useUserData } from "../../hooks/UserContext";
import { Container } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import PersonalAddressList from "../../components/AddressComponent/personalAddressList";
import { capitalizeFirstLetter } from "../../extension/string.ts";
import ModalApp from "../../components/ModalApp";
import { cardsApi } from "../OrderResumePag/_services/api";
import { Text } from "./styles";
import { getCardBinAndBrand } from "../OrderResumePag/_utils/card";
import { Divider } from "@mui/material";
import { useNavigate } from "react-router";
import { PencilSimpleLine } from "@phosphor-icons/react";
import EmailModal from "./_components/EmailModal";
import { updateCustomerEmail } from "./_services/customerService";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";
import {
  getCustomerFromMemory,
  setCustomerInMemory,
} from "../../lib/sharedSessionMemory";

export default function MyAccountPJ() {
  const screenName = useScreenTracking();
  // 'pf' ou 'pj'
  const [currentView, setCurrentView] = useState("pj");
  const [Loading, setLoading] = useState(true);
  const [cards, setCards] = useState([]);
  const [address, setAddress] = useState({});
  const [addresses, setAddresses] = useState([]);
  const [open, setOpen] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [pfEmail, setPfEmail] = useState("");
  const [refreshCards, setRefreshCards] = useState();
  const [isLoading, setIsLoading] = useState(null);
  const { user, setMainCard } = useUserData();
  const jwt = useUserData();
  // eslint-disable-next-line
  const customer_address = jwt?.addressesData || [];
  const dataUser = jwt?.userData.data;
  const navigate = useNavigate();

  async function handleEndereco(address) {
    let result = null;
    address.customerUuid = dataUser.uuid;

    if (address.main === "1") {
      try {
        const currentMain = addresses.find((addr) => addr.main === "1");

        if (currentMain && currentMain.uuid !== address.uuid) {
          const updateMainResult = await editAddresses({
            ...currentMain,
            uuid: currentMain.uuid,
            customerUuid: dataUser.uuid,
            main: "0",
          });

          if (!updateMainResult.status) {
            notify("Erro ao remover o endereço principal anterior", "error");
            return;
          }
        }

        if (address.uuid) {
          result = await editAddresses(user.cpf, address);
        } else {
          result = await addAddress(user.cpf, address);
        }

        if (!result.status) {
          notify(result.data.message, "error");
          return;
        }

        notify(result.data.message, "success");

        trackClick({
          title: address.uuid ? "salvar" : "adicionar",
          contentType: address.uuid
            ? "atualizar-dados-do-endereco"
            : "cadastrar-novo-endereco",
          screenName,
          tagId: tagIdFromLegacySuffix("07"),
        });

        jwt.setUpdateAddresses(new Date());

        // Atualizar a listagem de endereços
        const updatedAddresses = await getAddresses(dataUser.cpf);
        setAddresses(updatedAddresses);
        setOpen(false);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Erro ao atualizar endereço principal:", error);
        notify("Erro ao atualizar endereço", "error");
      } finally {
        return;
      }
    } else {
      if (address.uuid) {
        result = await editAddresses(user.cpf, address);
      } else {
        result = await addAddress(user.cpf, address);
      }

      if (!result.status) {
        notify(result.data.message, "error");
        return;
      }

      notify(result.data.message, "success");

      trackClick({
        title: address.uuid ? "salvar" : "adicionar",
        contentType: address.uuid
          ? "atualizar-dados-do-endereco"
          : "cadastrar-novo-endereco",
        screenName,
        tagId: tagIdFromLegacySuffix("07"),
      });

      jwt.setUpdateAddresses(new Date());

      // Atualizar a listagem de endereços
      const updatedAddresses = await getAddresses(dataUser.cpf);
      setAddresses(updatedAddresses);
      setOpen(false);
    }
  }

  async function onClickDelAddress(uuidAddress) {
    let message = "";
    let type = "success";

    try {
      const response = await deleteAddress(jwt?.user?.cpf, uuidAddress);
      message = response.message;

      trackClick({
        title: "excluir",
        contentType: "atualizar-dados-do-endereco",
        screenName,
        tagId: tagIdFromLegacySuffix("07"),
      });

      // Atualizar a listagem de endereços após deletar
      const updatedAddresses = await getAddresses(dataUser.cpf);
      setAddresses(updatedAddresses);
    } catch (error) {
      message = error.message;
      type = "error";
    } finally {
      notify(message, type);
      jwt.setUpdateAddresses(new Date());
    }
  }

  useEffect(() => {
    if (dataUser) {
      const fetchData = async () => {
        const cardResponse = await getCard();
        const cardsArr = cardResponse || [];
        setCards(() => [...cardsArr]);

        const userAddresses = await getAddresses(dataUser.cpf);
        setAddresses(userAddresses);

        setLoading(false);
      };
      fetchData();
    }
  }, [dataUser, Loading, refreshCards]);

  useEffect(() => {
    if (dataUser?.email) {
      setPfEmail(dataUser.email);
    }
  }, [dataUser]);

  function adicionarEndereco() {
    trackClick({
      title: "adicionar",
      contentType: "enderecos-cadastrados",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });

    setAddress({});
    setOpen(true);
  }

  function onOpenEmailModal() {
    trackClick({
      title: "alterar",
      contentType: "dados-pessoais",
      screenName,
      tagId: tagIdFromLegacySuffix("06"),
    });

    setOpenEmailModal(true);
  }

  function onCloseEmailModal() {
    setOpenEmailModal(false);
  }

  async function onSaveEmail(updatedEmail) {
    if (!updatedEmail || !updatedEmail.includes("@")) {
      notify("Informe um e-mail válido.", "error");
      return;
    }

    try {
      setIsLoading(true);
      const response = await updateCustomerEmail(dataUser.cpf, updatedEmail);

      if (response.status !== 200) {
        notify("Erro ao atualizar o e-mail.", "error");
        return;
      }

      // Atualiza o estado local
      setPfEmail(updatedEmail);

      // Atualiza o estado compartilhado com o novo e-mail
      const userData = getCustomerFromMemory();
      if (userData) {
        userData.data.email = updatedEmail;
        setCustomerInMemory(userData);
        jwt.setUpdateUser(new Date());
      }

      notify("E-mail atualizado com sucesso.", "success");

      trackClick({
        title: "salvar",
        contentType: "dados-pessoais",
        screenName,
        tagId: tagIdFromLegacySuffix("07"),
      });

      setOpenEmailModal(false);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Erro ao atualizar e-mail:", error);
      const errorMessage =
        error.response?.data?.message || "Erro ao atualizar o e-mail.";
      notify(errorMessage, "error");
    } finally {
      setIsLoading(false);
    }
  }

  async function onSaveCard(values, card_hash) {
    const last_digits = values.card_number?.substr(-4);
    const { bin, brand } = getCardBinAndBrand(values.card_number);
    const [expirationMonth, expirationYear] =
      values.card_expiration_date.split("/");

    values.card_save = true;

    const createdCard = {
      brand: brand,
      bin: bin,
      expiration_month: expirationMonth,
      expiration_year: expirationYear,
      holder_cpf: values.card_document,
      holder_name: values.card_holder_name,
      last_four_digits: last_digits,
      main: cards.length >= 1 ? false : true,
    };

    try {
      const payload = {
        cardToken: card_hash,
        bin: createdCard.bin,
        brand: createdCard.brand,
        expirationMonth: createdCard.expiration_month,
        expirationYear: createdCard.expiration_year,
        holderName: createdCard.holder_name,
        lastFourDigits: createdCard.last_four_digits,
        main: createdCard.main,
      };

      setIsLoading(true);
      const { status } = await cardsApi.post(
        `/v1/customer/${dataUser.cpf}/card`,
        payload,
      );

      if (status !== 200) {
        notify("Erro ao cadastrar o cartão", "error");
        return;
      }

      notify("Cartão cadastrado com sucesso.", "success");

      setCards([createdCard, ...cards]);
      setMainCard(createdCard);
      setRefreshCards(new Date());
    } catch (error) {
      notify("Erro ao cadastrar o cartão", "error");
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  async function getCard() {
    try {
      const { data, status } = await cardsApi.get(
        `/v1/customer/${dataUser.cpf}/card`,
      );

      if (status !== 200) {
        notify("Erro ao obter os dados do cartão", "error");
        return;
      }

      return data.data;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      notify("Erro ao obter os dados do cartão.", "error");
    }
  }

  return (
    !Loading && (
      <>
        <ModalApp
          show={open}
          handleModal={() => {
            trackClick({
              title: "fechar-modal",
              contentType: "cadastrar-novo-endereco",
              screenName,
              tagId: tagIdFromLegacySuffix("07"),
            });
            setOpen(false);
          }}
        >
          <AddressComponent
            onConfirm={handleEndereco}
            onCancel={() => setOpen(false)}
            address={address}
          />
        </ModalApp>
        <EmailModal
          show={openEmailModal}
          defaultEmail={pfEmail}
          onClose={onCloseEmailModal}
          onSave={onSaveEmail}
        />
        <div className="wl-page">
          <Container>
            <div
              className="row gx-3 justify-content-between"
              style={{ marginTop: "42px", marginBottom: "16px" }}
              role="group"
              aria-label="Alternar entre dados PJ e PF"
            >
              <div className="col-6 d-flex justify-content-start">
                <button
                  type="button"
                  className={
                    currentView === "pj" ? "btn-default-wl" : "btn-outline-wl"
                  }
                  aria-pressed={currentView === "pj"}
                  aria-controls="panel-pj"
                  onClick={() => {
                    trackClick({
                      title: "dados-pj",
                      contentType: "navegacao",
                      screenName,
                      tagId: tagIdFromLegacySuffix("06"),
                    });
                    setCurrentView("pj");
                  }}
                  style={{
                    width: "150px",
                    padding: "12px 8px",
                    height: "75px",
                  }}
                >
                  DADOS PJ
                </button>
              </div>
              <div className="col-6 d-flex justify-content-end">
                <button
                  type="button"
                  className={
                    currentView === "pf" ? "btn-default-wl" : "btn-outline-wl"
                  }
                  aria-pressed={currentView === "pf"}
                  aria-controls="panel-pf"
                  onClick={() => {
                    trackClick({
                      title: "dados-pf",
                      contentType: "navegacao",
                      screenName,
                      tagId: tagIdFromLegacySuffix("06"),
                    });
                    setCurrentView("pf");
                  }}
                  style={{
                    width: "150px",
                    padding: "12px 8px",
                    height: "75px",
                  }}
                >
                  DADOS PF
                </button>
              </div>
            </div>
          </Container>
          {currentView === "pf" && (
            <Container>
              <div className="group-disabled-color color-opacty-60 mt-5">
                <div className="input-group mb-5">
                  <TextField
                    type="text"
                    className="w-100"
                    placeholder="Nome"
                    value={capitalizeFirstLetter(dataUser.nome)}
                    variant="standard"
                    readOnly
                  />
                  <span className="input-group-wl">
                    <img
                      src={LockIcon}
                      style={{ height: 16, width: 16 }}
                      className="text-black"
                      alt="lock"
                    />
                  </span>
                </div>

                <div className="input-group mb-5">
                  <TextField
                    type="text"
                    className="w-100"
                    placeholder="CNPJ"
                    value={capitalizeFirstLetter(dataUser.cpf)}
                    variant="standard"
                    readOnly
                  />
                  <span className="input-group-wl">
                    <img
                      src={LockIcon}
                      style={{ height: 16, width: 16 }}
                      className="text-black"
                      alt="lock"
                    />
                  </span>
                </div>

                <div className="input-group mb-5">
                  <TextField
                    type="text"
                    className="w-100"
                    placeholder="Digite um e-mail válido"
                    value={pfEmail}
                    variant="standard"
                    onClick={!pfEmail ? onOpenEmailModal : undefined}
                    InputProps={{ readOnly: true }}
                    style={{ cursor: !pfEmail ? "pointer" : "default" }}
                  />
                  <span
                    className="input-group-wl"
                    onClick={!pfEmail ? onOpenEmailModal : undefined}
                    style={{ cursor: !pfEmail ? "pointer" : "default" }}
                  >
                    {pfEmail ? (
                      <img
                        src={LockIcon}
                        style={{ height: 16, width: 16 }}
                        className="text-black"
                        alt="lock"
                      />
                    ) : (
                      <PencilSimpleLine size={18} weight="regular" />
                    )}
                  </span>
                </div>
              </div>
              <div className="mt-4">
                <p className="text-xs mb-1 text-text_primary_color italic">
                  Para utilizar os benefícios do programa Safra Rewards para
                  empresas, faça login utilizando o e-mail cadastrado. Para
                  altera-lo é necessário entrar em contato com o banco.
                </p>
              </div>
            </Container>
          )}
          {currentView === "pj" && (
            <Container>
              <div className="group-disabled-color color-opacty-60 mt-5">
                <div className="input-group mb-5">
                  <TextField
                    type="text"
                    className="w-100"
                    placeholder="Nome"
                    value={jwt?.companyData?.nome}
                    variant="standard"
                    readOnly
                  />
                  <span className="input-group-wl">
                    <img
                      src={LockIcon}
                      style={{ height: 16, width: 16 }}
                      className="text-black"
                      alt="lock"
                    />
                  </span>
                </div>

                <div className="input-group mb-5">
                  <TextField
                    type="text"
                    className="w-100"
                    placeholder="CNPJ"
                    value={jwt?.companyData?.cpf}
                    variant="standard"
                    readOnly
                  />
                  <span className="input-group-wl">
                    <img
                      src={LockIcon}
                      style={{ height: 16, width: 16 }}
                      className="text-black"
                      alt="lock"
                    />
                  </span>
                </div>

                <div className="input-group mb-5">
                  <TextField
                    type="text"
                    className="w-100"
                    placeholder="Email"
                    value={jwt?.companyData?.email}
                    variant="standard"
                    readOnly
                  />
                  <span className="input-group-wl">
                    <img
                      src={LockIcon}
                      style={{ height: 16, width: 16 }}
                      className="text-black"
                      alt="lock"
                    />
                  </span>
                </div>
              </div>
              <Text className="mt-5">
                <p className="font-wl- text-mg color-text-dark mb-4">
                  Endereços cadastrados
                </p>
                <PersonalAddressList
                  addresses={Array.isArray(addresses) ? addresses : []}
                  onClickDelAddress={onClickDelAddress}
                  setAddress={setAddress}
                  setOpen={setOpen}
                  open={open}
                  address={address}
                  handleEndereco={handleEndereco}
                  screenName={screenName}
                />
              </Text>
            </Container>
          )}
          {currentView === "pj" && <Divider style={{ margin: "20px 24px" }} />}
          <Container
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <button
              className="btn-default-wl"
              style={{ maxWidth: "200px" }}
              onClick={() => {
                trackClick({
                  title: "ir-para-home",
                  contentType: "navegacao",
                  screenName,
                  tagId: tagIdFromLegacySuffix("06"),
                });
                navigate("/");
              }}
            >
              IR PARA HOME
            </button>
          </Container>
        </div>
      </>
    )
  );
}
